<div id="viewer-accessibility" class="relative flex-1 flex flex-col px-base overflow-y-auto">
    <div
        class="sticky top-0 bg-white w-full h-12 px-1 pt-base flex justify-between items-start text-viewer-secondary text-lg">
        <div class="flex items-center justify-center gap-x-2">
            <meta-icon icon="calendar"></meta-icon>
            <p class="inline-block">{{'Events' | translate}}</p>
        </div>
        <button class="inline-flex items-center justify-center gap-x-2" (click)="onClose()">
            <p>{{'Close' | translate}}</p>
            <meta-icon icon="close" additionalClasses="text-base"></meta-icon>
        </button>
    </div>

    <div class="px-1 flex flex-col overflow-y-auto mt-4 pt-2 border-t border-t-gray-300 scrollbar-custom h-full">
        <meta-calendar [hideFilterButton]="true"  [desktopLabel]="config.viewerDesktopLabel" [mobileLabel]="config.viewerDesktopLabel" [fixedSearch]="fixedSearch" [toolbarSetup]="config.viewerToolbarConfig"></meta-calendar>
    </div>
</div>